import React, { useMemo, useState, useEffect } from "react";
import Parse from "parse";
import moment from "moment-with-locales-es6";
import { useNavigate } from "react-router-dom";
import "../../StylesPages/dashboard.css";
import ShowUser from "../ShowUser/ShowUser";
import { Box, Image, Button, Text } from "@chakra-ui/react";
import Slider from "react-slick";

import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";

import "./styles.css";

export const ProfileVisit = () => {
  const navigate = useNavigate();

  const [visiteursIds, setVisiteursIds] = useState([]);
  const [showVisiteursIds, setShowVisiteursIds] = useState(false);
  const [noNewVisit, setNoNewVisit] = useState(true);
  const vp = useMemo(() => {
    if (visiteursIds) {
      return visiteursIds;
    }
  }, [visiteursIds]);

  const onClick = () => {
    setShowVisiteursIds(!showVisiteursIds);
  };

  async function fetchVisitedProfileLastWeek() {
    const VisitProfile = Parse.Object.extend("VisitProfile");
    const query = new Parse.Query(VisitProfile);
    const currentUser = Parse.User.current();
    query.equalTo("user2", currentUser);
    query.greaterThanOrEqualTo(
      "createdAt",
      moment().subtract(30, "days").startOf("month").toDate()
    );
    query.descending("createdAt");

    const visitedProfile = await query.find().catch((error) => {
      alert(
        "Failed to update user informations, with error code: " + error.message
      );
      Parse.User.logOut();
      navigate("/");
    });

    let ids = [];
    if (visitedProfile !== "undefined") {
      visitedProfile.forEach((vp) => {
        ids.push({ id: vp.get("user1").id, user: vp });
      });
    }

    const key = "id";

    const arrayUniqueByKey = [
      ...new Map(ids.map((item) => [item[key], item])).values(),
    ];

    setVisiteursIds(arrayUniqueByKey);

    // setAllCandidatsParOffre(candidatsParOffre);
    // setOfferPos(ids);
    // setOffersTitle(titles);
    // setCandidatsToShow(candidatsParOffre.get(ids[0]));

    return visitedProfile;
  }

  useEffect(() => {
    fetchVisitedProfileLastWeek();
  }, []);

  var settings = {
    className: "center",
    infinite: false,
    centerPadding: "60px",
    slidesToShow: 8,
    swipeToSlide: true,
    afterChange: function (index) {
      console.log(
        `Slider Changed to: ${index + 1}, background: #222; color: #bada55`
      );
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Box mt={"20px"} px={[8, 8, 12, 12]}>
      <Text
        fontFamily={"Sofia Pro"}
        fontSize={"14px"}
        fontWeight={400}
        align={"left"}
      >
        Au cours du mois {[3, 7, 9].includes(moment().month()) ? "d’" : "de "}
        {moment().format("MMMM")}, votre profil a été visité par
      </Text>
      <Text
        fontFamily={"Sofia Pro"}
        fontSize={"24px"}
        fontWeight={900}
        align={"left"}
      >
        {visiteursIds
          ? visiteursIds.length > 1
            ? `${visiteursIds.length} Profils`
            : `${visiteursIds.length} Profil`
          : ""}
      </Text>
      <Button
        className="add-event"
        onClick={onClick}
        w={"50%"}
        paddingInline="20px"
        marginBottom={showVisiteursIds ? "10px" : "30px"}
        bg="#f1404b"
        borderRadius={20}
        color="white"
      >
        {showVisiteursIds ? "Fermer" : "Voir Visiteurs"}
      </Button>
      "<br></br>
      <Box pb={"2px"} color={"red"}>
        {showVisiteursIds && visiteursIds ? (
          <Slider {...settings}>
            {visiteursIds.map((userId, k) => {
              return (
                <Box px={0}>
                  <ShowUser
                    key={k}
                    hide={true}
                    showAvatarOnly={true}
                    userId={userId.id}
                    visiteursProfile={userId.user}
                  ></ShowUser>
                </Box>
              );
            })}
          </Slider>
        ) : (
          ""
        )}
      </Box>
      {/* {showVisiteursIds && visiteursIds
        ? visiteursIds.map((userId, k) => {
            return visiteursProfile[k].get("seen") == false ? (
              // console.log(visiteursProfile[k])
              <ShowUser
                hide={true}
                showAvatarOnly={false}
                userId={userId}
                visiteursProfile={visiteursProfile[k]}
              ></ShowUser>
            ) : (
              ""
            );
          })
        : ""} */}
      {/* {showVisiteursIds || (showVisiteursIds && noNewVisit)
        ? "No new visit"
        : ""} */}
    </Box>
  );
};

export default ProfileVisit;
